import {DateRange} from 'Core/models/DateRange';
import {FilterOption, FilterOptionValue} from 'Core/models/FilterOption';
import {CompleteInequalityRange, InequalityRange, isValidInequalityRange} from 'Core/models/InequalityRange';
import * as O from 'fp-ts/lib/Option';
import {compose} from 'redux';
import * as Luxon from 'luxon';

export const addFilterParameters = (filter: any) => {
  const isDateRange = compose(
    keys => keys && keys.length > 0 && keys.every(x => ['startDate', 'endDate'].includes(x)),
    Object.keys
  );
  const isSpecifiedInequalityRange = (filter: O.Option<InequalityRange>): filter is O.Some<CompleteInequalityRange> =>
    O.isSome(filter) && isValidInequalityRange(filter.value);

  const isNonEmptyDateRange = (value: DateRange) => Boolean(value.startDate) || Boolean(value.endDate);
  const isNonEmptyFilterItem = (key: string) => {
    if (isDateRange(filter[key])) {
      return isNonEmptyDateRange(filter[key]);
    } else if (O.isNone(filter[key])) {
      return false;
    } else if (FilterOptionValue.is.EmptyOption(filter[key])) {
      return false;
    } else if (filter[key] instanceof Array) {
      return true;
    } else if (['true', 'false'].includes(filter[key].toString())) {
      return true;
    } else {
      return Boolean(filter[key]);
    }
  };
  const toFilterKey = (key: string) => {
    if (isDateRange(filter[key])) {

      const startDateFilter = filter[key].startDate
        ? `${key}StartDateFilter=${Luxon.DateTime.utc(
                        filter[key].startDate.getFullYear(), 
                       (filter[key].startDate.getMonth() + 1), 
                        filter[key].startDate.getDate()).startOf('day').toISO()}`
        : '';

      const endDateFilter = filter[key].endDate 
        ? `${key}EndDateFilter=${Luxon.DateTime.utc(
                      filter[key].endDate.getFullYear(), 
                    (filter[key].endDate.getMonth() + 1), 
                      filter[key].endDate.getDate()).endOf('day').toISO()}`
        : '';	  

      return [filter[key].startDate ? startDateFilter : null, filter[key].endDate ? endDateFilter : null]
        .filter(Boolean)
        .join('&');
    } else if (FilterOptionValue.is.SelectedOption(filter[key])) {
      const value = filter[key].value;
      return `${key}=${value}`;
    } else if (filter[key] instanceof Array) {
      // Handle List of Status
      if (filter[key].length > 0 && FilterOptionValue.is.SelectedOption(filter[key][0])) {
        return `${key}=${filter[key].map((x: FilterOption) => x.name).join(',')}`;
      }

      return filter[key].length > 0 ? `${key}=${filter[key]}` : '';
    } else if (['true', 'false'].includes(filter[key].toString())) {
      return `${key}=${filter[key].toString()}`;
    } else if (filter[key].value !== undefined && !isSpecifiedInequalityRange(filter[key].value)) {
      const inequalityFilter = filter[key].value;
      return `${key}=${inequalityFilter.operator},${inequalityFilter.operand}`;
    } else {
      return Boolean(filter[key]) ? `${key}=${encodeURIComponent(filter[key])}` : '';
    }
  };
  const result = Boolean(filter)
    ? '?' +
      Object.keys(filter)
        .filter(key => filter[key] !== undefined && filter[key] !== null)
        .filter(isNonEmptyFilterItem)
        .map(value => toFilterKey(value))
        .join('&')
    : '';

  return result;
};
